import { useEffect, useState } from 'react';
import { api } from '../../utils/api';
import { useAuth } from '../../context/AuthContext';

function timeAgo(date) {
  const d=(Date.now()-new Date(date))/1000;
  if(d<60) return 'agora';
  if(d<3600) return Math.floor(d/60)+'min';
  if(d<86400) return Math.floor(d/3600)+'h';
  return Math.floor(d/86400)+'d';
}

export default function MentorNotificacoes() {
  const { token } = useAuth();
  const [notifs, setNotifs] = useState([]);
  const [emergencias, setEmergencias] = useState([]);
  const [aba, setAba] = useState('notifs');

  useEffect(() => {
    api.get('/mentor/notificacoes', token).then(setNotifs);
    api.get('/mentor/emergencias', token).then(setEmergencias).catch(()=>{});
  }, [token]);

  const marcarLido = async (id) => {
    await api.patch(`/mentor/notificacoes/${id}/lido`, {}, token);
    setNotifs(prev => prev.map(n => n.id===id ? {...n, lido:true} : n));
  };

  const naoLidas = notifs.filter(n=>!n.lido).length;

  // Agrupar emergências por aluno
  const emergenciasPorAluno = emergencias.reduce((acc, e) => {
    if (!acc[e.aluno_id]) acc[e.aluno_id] = { ...e, total: 0 };
    acc[e.aluno_id].total++;
    return acc;
  }, {});
  const listaEmergencias = Object.values(emergenciasPorAluno).sort((a,b) => new Date(b.criado_em) - new Date(a.criado_em));

  return (
    <div style={{padding:'28px 32px',maxWidth:640}}>
      <div style={{marginBottom:24}}>
        <div style={{fontSize:22,fontWeight:700,letterSpacing:'-.02em'}}>Notificações</div>
        <div style={{fontSize:13,color:'#6B7289',marginTop:3}}>{naoLidas} não lida{naoLidas!==1?'s':''}</div>
      </div>

      {/* Tabs */}
      <div style={{display:'flex',gap:8,marginBottom:20}}>
        <button onClick={()=>setAba('notifs')}
          style={{padding:'7px 18px',borderRadius:8,border:'none',cursor:'pointer',fontSize:13,fontWeight:600,
            background:aba==='notifs'?'#1A2ECC':'#F4F5F9',color:aba==='notifs'?'#fff':'#6B7289'}}>
          Notificações {naoLidas>0&&<span style={{background:'#D63B3B',color:'#fff',borderRadius:99,padding:'1px 6px',fontSize:10,marginLeft:4}}>{naoLidas}</span>}
        </button>
        <button onClick={()=>setAba('emergencias')}
          style={{padding:'7px 18px',borderRadius:8,border:'none',cursor:'pointer',fontSize:13,fontWeight:600,
            background:aba==='emergencias'?'#D63B3B':'#F4F5F9',color:aba==='emergencias'?'#fff':'#6B7289'}}>
          🆘 Emergências {listaEmergencias.length>0&&<span style={{background:'#fff',color:'#D63B3B',borderRadius:99,padding:'1px 6px',fontSize:10,marginLeft:4,fontWeight:700}}>{listaEmergencias.length}</span>}
        </button>
      </div>

      {/* Notificações */}
      {aba==='notifs' && <>
        {notifs.length===0 && (
          <div className="card" style={{textAlign:'center',padding:40,color:'#6B7289'}}>
            <div style={{fontSize:24,marginBottom:8}}>🔔</div>
            Nenhuma notificação ainda.
          </div>
        )}
        {notifs.map(n => (
          <div key={n.id} className="card" style={{marginBottom:10,display:'flex',alignItems:'center',gap:14,
            background:n.lido?'#fff':'#EBF0FF',borderColor:n.lido?'#E4E6EF':'#94A1FF'}}>
            <div style={{fontSize:22,flexShrink:0}}>{n.tipo==='fase_concluida'?'✅':'🔔'}</div>
            <div style={{flex:1}}>
              <div style={{fontSize:13,fontWeight:n.lido?400:600}}>{n.mensagem}</div>
              {n.operacao_nome && <div style={{fontSize:11,color:'#6B7289',marginTop:2}}>Operação: {n.operacao_nome}</div>}
              <div style={{fontSize:11,color:'#9095A8',marginTop:2}}>{timeAgo(n.criado_em)}</div>
            </div>
            {!n.lido && (
              <button className="btn-ghost" style={{fontSize:11,padding:'5px 10px',flexShrink:0}} onClick={()=>marcarLido(n.id)}>
                Marcar lido
              </button>
            )}
          </div>
        ))}
      </>}

      {/* Emergências */}
      {aba==='emergencias' && <>
        {listaEmergencias.length===0 && (
          <div className="card" style={{textAlign:'center',padding:40,color:'#6B7289'}}>
            <div style={{fontSize:24,marginBottom:8}}>🆘</div>
            Nenhum chamado de emergência.
          </div>
        )}
        {listaEmergencias.map(e => (
          <div key={e.aluno_id} className="card" style={{marginBottom:10,display:'flex',alignItems:'center',gap:14,
            background:'#FFF5F5',border:'1px solid #FCA5A5'}}>
            <div style={{fontSize:28,flexShrink:0}}>🆘</div>
            <div style={{flex:1}}>
              <div style={{fontSize:13,fontWeight:700,color:'#D63B3B'}}>{e.aluno_nome}</div>
              <div style={{fontSize:11,color:'#6B7289',marginTop:2}}>{e.email}</div>
              <div style={{fontSize:11,color:'#9095A8',marginTop:2}}>Último chamado: {timeAgo(e.criado_em)}</div>
            </div>
            <div style={{textAlign:'center',flexShrink:0}}>
              <div style={{fontSize:24,fontWeight:700,color:'#D63B3B'}}>{e.total}</div>
              <div style={{fontSize:10,color:'#9095A8'}}>chamado{e.total!==1?'s':''}</div>
            </div>
          </div>
        ))}
      </>}
    </div>
  );
}
